import axios from 'axios';
import React, { useEffect, useState } from 'react'
import './MoviePage.css'
import Tilt from 'react-parallax-tilt';
import { Link, useParams } from 'react-router-dom';


import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';
import BASE_URL from '../../constant';


function MoviePage() {


    const params = useParams();
    const {movieId} = params;
    const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    const [movieData, setMovieData] = useState({});
    const [backImgStyle, setBackImgStyle] = useState({});
    const [posterImage, setPosterImage] = useState("");


    useEffect(()=>{

        axios.get(`${BASE_URL}/bookmyshow/api/v1/movie/${movieId}`)
        .then(res => {
            setMovieData(res.data);
            setBackImgStyle({
                background : "url(" + res.data.backImage.url + ")",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition : "center",
            });
            setPosterImage(res.data.posterImage.url);
        })
        .catch(err => console.error(err));

    },[movieId]);


    return (
        <div className='moviePageContainer'>
        <Navbar />
        <div className="backImg mg" style={backImgStyle} >
            <div className="movieinfo">
                <Tilt glareMaxOpacity={0.4}
                glareEnable={true} glarePosition={"all"} trackOnWindow={false}
                glareBorderRadius={"10"} tiltReverse={true} 
                className="tiltCard">
                    <img src={posterImage} alt="Movie Poster" />
                </Tilt> 
                <div className="info">
                    <div className="movieName commonInfo">{movieData.name}</div>
                    <div className="rating commonInfo">Rating - {movieData.rating}/10</div>
                    <button className="reviewBtn commonInfo">
                        Add your rating & review <i className='fa-solid fa-arrow-right icon'></i>
                    </button>
                    <div className="formatLang commonInfo">
                        <div className="pills">2D</div>
                        {
                            (movieData.language) && movieData.language.map((lan,index)=>{
                                return <div key={index} className="pills">{lan}</div>
                            })
                        }
                    </div>
                    <div className="genrelength commonInfo">
                        <div className="epills">
                            <i className='fa-solid fa-film icon'></i>
                            &nbsp; {movieData.genre}
                        </div>
                        <div className="epills">
                            <i className='fa-solid fa-calendar icon'></i>
                            &nbsp; {movieData.releaseDate && movieData.releaseDate.substring(8, 10)} 
                            &nbsp; {movieData.releaseDate && monthArr[movieData.releaseDate.substring(5, 7)-1]} 
                            &nbsp; {movieData.releaseDate && movieData.releaseDate.substring(0, 4)}
                        </div>
                        <div className="epills"><i className='fa-solid fa-clock icon'></i> &nbsp; {movieData.movieLength}</div>
                    </div>
                    { (movieData && movieData.releaseStatus === "Released") ? 
                    <Link to={'/theatre-list/' + movieData._id}>
                        <button className="bookBtn">BOOK TICKETS</button>
                    </Link> : <div className="notRelMsg">Not Released Yet !</div> }
                </div>
            </div>
        </div>


        <div className="aboutMovie mg rmg">
            <div className="heading">About Movie</div>
            <div className="aboutTxt">{movieData.desc}</div>
        </div>

        <div className="videoTrailer mg rmg">
        <div className="heading">Video Trailer - </div>
        <Link to={movieData.videoTrailer} target="_blank" >
                {movieData.videoTrailer}
            </Link>
        </div>

        <div className="castContainer mg rmg" style={{marginBottom : "80px"}}>
            <div className="heading">Movie Cast</div>
            <div className="castCard">
                {
                    (movieData.cast) && movieData.cast.map((c,i)=>{
                        return <div key={i} className="castNames">{c}</div>
                    })
                }
            </div>
        </div>
        <Footer />
    </div>
    )
}

export default MoviePage
